import { useCallback, useEffect } from 'react'
import type { SavedReply } from '~publish/gql/graphql'

export const useSavedRepliesKeyboardNav = ({
  savedReplies,
  activeIndex,
  setActiveIndex,
}: {
  savedReplies: SavedReply[] | undefined | null
  activeIndex: number | null
  setActiveIndex: (index: number | null) => void
}): void => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent): void => {
      if (!savedReplies?.length) return

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault()
          setActiveIndex(
            activeIndex === null || activeIndex === savedReplies.length - 1
              ? 0
              : activeIndex + 1,
          )
          break
        case 'ArrowUp':
          event.preventDefault()
          setActiveIndex(
            activeIndex === null || activeIndex === 0
              ? savedReplies.length - 1
              : activeIndex - 1,
          )
          break
        case 'Escape':
          event.preventDefault()
          setActiveIndex(null)
          break
        default:
          break
      }
    },
    [savedReplies, activeIndex, setActiveIndex],
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return (): void => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])
}
